import Vue from 'vue';
import { truncate } from 'lodash';

/**
 * For more usage https://lodash.com/docs/4.17.11#truncate
 * @example
 * // Default length is 24
 * {{ String | truncate }}
 * {{ String | truncate({ length: Number }) }}
 * {{ String | truncate({ omission: Any }) }}
 */
Vue.filter('truncate', truncate);
